import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {Constants} from '../../shared/config/constants.config';
import {UserSurveyViewModel} from '../viewModels/userSurveyViewModel';

@Injectable()
export class SurveyService {
    constructor(private readonly httpClient: HttpClient, private readonly constants: Constants) {
    }

    getUserSurveys(): Observable<UserSurveyViewModel[]> {
        return this.httpClient.get<UserSurveyViewModel[]>(`${this.constants.apiURL()}/user/survey`);
    }
}
